import {DiscordIntegration} from './DiscordIntegration';
import * as React from 'react';
import {IFTTTIntegration} from './IFTTTIntegration';
import {IFTTTIntegrationV2} from './IFTTTIntegrationV2';

export const resolveWebHookEdit = (
  metaWebHookId,
  configuration,
  onConfigUpdate,
  validateAndGet
) => {
  switch (metaWebHookId) {
    case '13597a91-b45e-4105-a8ca-091e9c358dc9':
      return (
        <DiscordIntegration
          onConfigUpdate={onConfigUpdate}
          configuration={configuration}
          validateAndGet={validateAndGet}
        />
      );
    case '482583fb-dacb-4df6-9bb6-1855e454620c':
      return (
        <IFTTTIntegration
          onConfigUpdate={onConfigUpdate}
          configuration={configuration}
          validateAndGet={validateAndGet}
        />
      );
    case '50b602a8-bb03-4929-8d2c-75986741fb62':
      return (
        <IFTTTIntegrationV2
          onConfigUpdate={onConfigUpdate}
          configuration={configuration}
          validateAndGet={validateAndGet}
        />
      );
    default:
      return false;
  }
};
